import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./app";
import { loadSession, subscribeAuthProblems } from "./session/store";
import "./styles/base.css";
import "./styles/app.css";

subscribeAuthProblems();
void loadSession();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
